var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s6"},[_c('div',{staticClass:"container"},[_c('img',{staticClass:"title",attrs:{"src":require("@/assets/home/s6/title.png"),"alt":""}}),_c('div',{staticClass:"img-wrapper"},_vm._l((_vm.iconList),function(item){return _c('img',{key:item.id,staticClass:"icon",attrs:{"src":item.icon,"alt":""}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }